import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import { store, persistor } from './services/store/store';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import './index.css';
import FrontendErrorBoundary from './components/error/FrontendErrorBoundary';
import installGlobalErrorReporting from './monitoring/installGlobalErrorReporting';
import installBreadcrumbs from './monitoring/installBreadcrumbs';

// Watchdog: capture uncaught errors + promise rejections and forward them to
// the backend (/api/frontend-incidents -> #oatrx-errors). Never throws.
installGlobalErrorReporting();
// Breadcrumbs: record route changes + control clicks so an error report shows
// HOW the user got there. Labels only, never values.
installBreadcrumbs();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate persistor={persistor}>
				<BrowserRouter>
					<FrontendErrorBoundary>
						<App />
					</FrontendErrorBoundary>
				</BrowserRouter>
			</PersistGate>
		</Provider>
	</React.StrictMode>
)


